import { render, staticRenderFns } from "./useStaffDialog.vue?vue&type=template&id=3ef1d545&"
import script from "./useStaffDialog.vue?vue&type=script&lang=js&"
export * from "./useStaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./useStaffDialog.vue?vue&type=style&index=0&id=3ef1d545&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports